import Navbar from 'components/navbar';
import classes from './standardTimeLegend.module.scss';
import SetupTimeTable from 'screens/ReferenceScreen/components/SetupTable';
import CleanTimeTable from 'screens/ReferenceScreen/components/CleanTimeTable';
import ClearTimeTable from 'screens/ReferenceScreen/components/ClearTimeTable';
import LvTimeTable from 'screens/ReferenceScreen/components/LVTimeTable';
import ExtraDustyProducts from './components/ExtraDustyProducts';
import { Button } from 'primereact/button';
import { useStandardTimeLegend } from './useStandardTimeLegend.logic';
import { PrinterIcon } from 'lucide-react';

const StandardTimeLegend = () => {
  const { handlePrint, getDate } = useStandardTimeLegend();

  return (
    <div className={classes.standardTimeLegendContainer}>
      <Navbar heading="Standard Time Legend" />
      <div id="headerContainer" className={classes.headerContainer}>
        <div>
          <p>
            <span style={{ color: '#4D2E6D', fontWeight: '600' }}>Date: </span>
            {getDate()}
          </p>
        </div>
        <div>
          <Button
            id="print-btn"
            icon={<PrinterIcon color="#4D2E6D" />}
            rounded
            style={{ backgroundColor: '#D6B1FD', border: 'none' }}
            onClick={handlePrint}
          />
        </div>
      </div>
      <div className={classes.container}>
        <div>
          <SetupTimeTable showAddButton={false} showActionColumn={false} showAllRows={true} />
        </div>

        <div>
          <CleanTimeTable showAddButton={false} showActionColumn={false} showAllRows={true} />
        </div>

        <div>
          <ClearTimeTable showAddButton={false} showActionColumn={false} showAllRows={true} />
        </div>

        <div>
          <LvTimeTable showAddButton={false} showActionColumn={false} showAllRows={true} />
        </div>

        <div>
          <ExtraDustyProducts />
        </div>
      </div>
    </div>
  );
};

export default StandardTimeLegend;
